module.exports = __webpack_public_path__ + "static/media/charity.7644881d.webp";